import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { GradientLogoProps } from '../../../types';

const GradientLogo = ({ isMobile }: GradientLogoProps) => {
  const theme = useTheme();
  return (
    <Typography
      variant="h6"
      component={Link}
      to="/"
      noWrap
      sx={{
        mr: 2,
        fontWeight: 800,
        textDecoration: 'none',
        flexGrow: isMobile ? 1 : 0,
        background:
          theme.palette.mode === 'dark'
            ? 'linear-gradient(45deg, #90caf9 30%, #64b5f6 90%)'
            : 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        textShadow:
          theme.palette.mode === 'dark'
            ? '2px 2px 4px rgba(255,255,255,0.1)'
            : '2px 2px 4px rgba(0,0,0,0.1)',
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        letterSpacing: '-0.02em',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}
    >
      Get to Know .me
    </Typography>
  );
};

export default GradientLogo;
